'use strict';
import {API_URL} from '../constants';
import {firebaseAuthSuccess, requestLogout} from '../../auth/actions';
import {getApiToken} from '../../auth/reducers/state';
import {pingServerError, pingServerSuccess} from '../../settings/actions';
import {Observable} from 'rxjs/Observable';
import {LOAD} from 'redux-storage';

export const BASE_REDUX_LIST_OPTIONS = {
  crossDomain: true,
  getToken: getApiToken,
  baseApiUrl: `${API_URL}/api`,
  baseServerUrl: API_URL,
  isAppReady$,
  isOnline$,
  isOffline$,
};

function isAppReady$(action$) {
  return Observable
    .combineLatest(
      Observable.merge(
        action$.ofType(pingServerSuccess.TYPE).mapTo(true),
        action$.ofType(pingServerError.TYPE).mapTo(false),
      ),
      action$.ofType(firebaseAuthSuccess.TYPE),
      action$.ofType(LOAD),
      isOnline => isOnline
    )
    .mergeMap(isOnline => isOnline ? Observable.of(true) : action$.ofType(pingServerSuccess.TYPE))
    .takeUntil(action$.ofType(requestLogout.TYPE))
    .take(1);
}

function isOnline$(action$) {
  return action$.ofType(pingServerSuccess.TYPE);
}

function isOffline$(action$) {
  return action$.ofType(pingServerError.TYPE, requestLogout.TYPE);
}



// WEBPACK FOOTER //
// ./src/js/config/redux-list/index.js